import _ from 'lodash';
import { ColumnDetails, ColumnType } from '../../../grid/types/common';
import { IntEnumConditions, StringConditions } from '../../../grid/gridFilters/types';
import { ViewConfiguration } from '../../../grid/gridView/types';

export interface MobileSecurityCompanyRecord {
  _id: string;
  companyName: string;
  companyType: MobileSecurityCompanyType;
  accountStatus: MobileSecurityAccountStatus;
  daysUntilExpire?: number;
}

export enum Column {
  MOBILE_SECURITY_COMPANY_NAME,
  MOBILE_SECURITY_COMPANY_TYPE,
  MOBILE_SECURITY_ACCOUNT_STATUS,
  MOBILE_SECURITY_ACTIONS,
}

export enum ColumnKeys {
  MOBILE_SECURITY_COMPANY_NAME = 'companyName',
  MOBILE_SECURITY_COMPANY_TYPE = 'companyType',
  MOBILE_SECURITY_ACCOUNT_STATUS = 'accountStatus',
  MOBILE_SECURITY_ACTIONS = 'actions'
}

export const DISPLAYED_FILTERS = [
  { [ColumnKeys.MOBILE_SECURITY_COMPANY_NAME]: { contains: '' } },
  { [ColumnKeys.MOBILE_SECURITY_COMPANY_TYPE]: { in: [] } },
  { [ColumnKeys.MOBILE_SECURITY_ACCOUNT_STATUS]: { in: [] } },
];

export const PREDEFINED_FILTERS_KEYS = [
  ColumnKeys.MOBILE_SECURITY_COMPANY_NAME,
  ColumnKeys.MOBILE_SECURITY_COMPANY_TYPE,
  ColumnKeys.MOBILE_SECURITY_ACCOUNT_STATUS,
];

export const DISPLAYED_COLUMNS = _.range(Object.keys(Column).length);

export enum MobileSecurityCompanyType {
  CUSTOMER,
  PARTNER,
}

export function getMobileSecurityCompanyTypeValues(translateFn: Function) {
  return [
    {
      label: translateFn('Customer'),
      value: MobileSecurityCompanyType.CUSTOMER,
    },
    {
      label: translateFn('Partner'),
      value: MobileSecurityCompanyType.PARTNER,
    },
  ];
}

export enum MobileSecurityAccountStatus {
  NOT_CREATED = 0,
  CREATED,
  EXPIRED,
}

export function getMobileSecurityAccountStatusValues(translateFn: Function) {
  return [
    {
      label: translateFn('Not created'),
      value: MobileSecurityAccountStatus.NOT_CREATED,
    },
    {
      label: translateFn('Created'),
      value: MobileSecurityAccountStatus.CREATED,
    },
    {
      label: translateFn('Expired'),
      value: MobileSecurityAccountStatus.EXPIRED,
    },
  ];
}

export function getColumnDetails(translateFn: Function): ColumnDetails<Column, ColumnKeys>[] {
  return [
    {
      column: Column.MOBILE_SECURITY_COMPANY_NAME,
      key: ColumnKeys.MOBILE_SECURITY_COMPANY_NAME,
      columnName: translateFn('Company name'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
      width: '260px',
    },
    {
      column: Column.MOBILE_SECURITY_COMPANY_TYPE,
      key: ColumnKeys.MOBILE_SECURITY_COMPANY_TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.ENUM,
      values: getMobileSecurityCompanyTypeValues(translateFn),
      removable: false,
      sortable: true,
      editingDisabled: true,
      width: '180px',
    },
    {
      column: Column.MOBILE_SECURITY_ACCOUNT_STATUS,
      key: ColumnKeys.MOBILE_SECURITY_ACCOUNT_STATUS,
      columnName: translateFn('Account status'),
      type: ColumnType.ENUM,
      values: getMobileSecurityAccountStatusValues(translateFn),
      removable: false,
      sortable: true,
      editingDisabled: true,
      width: '180px',
    },
    {
      column: Column.MOBILE_SECURITY_ACTIONS,
      key: ColumnKeys.MOBILE_SECURITY_ACTIONS,
      columnName: '',
      type: ColumnType.ACTION,
      removable: false,
      filteringDisabled: true,
      flexGrow: 1,
    }
  ];
}

export interface MobileSecurityCompanyGridWebComponentSchema {
  view: ViewConfiguration<Column, ColumnKeys>;
  columns: Array<ColumnDetails<Column, ColumnKeys>>;
}

export interface MobileSecurityCompanyGridGridItem {
  _id: string;
  companyName: string;
  companyType: MobileSecurityCompanyType;
  accountStatus: MobileSecurityAccountStatus;
  daysUntilExpire?: number;
}

interface Filter {
  companyName?: StringConditions;
  companyType?: IntEnumConditions;
  accountStatus?: IntEnumConditions;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<MobileSecurityCompanyGridGridItem>;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface UpdateSettingsRequest {
  viewId: string;
  columns?: Array<Column>;
  compactView?: boolean;
  pageSize?: number;
}

export enum AccountAction {
  CREATE = 'create-account',
  CONSOLE = 'open-console',
  ACTIVATION = 'send-activation',
}
